import React, { Fragment, useState, useEffect } from "react";
import history from "../../../../history";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import QueueIcon from "@material-ui/icons/Queue";
import CloseIcon from "@material-ui/icons/Close";
import PrintIcon from "@material-ui/icons/Print";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DescriptionIcon from "@material-ui/icons/Description";
import Modal from "@material-ui/core/Modal";
import { Button } from "reactstrap";
import ModalHistory from "../../ClinicHistoryComplete/Components/ModalHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faFileMedical,
  faFileAudio,
  faFileAlt,
  faBiohazard,
  faCommentMedical,
  faRadiation,
  faFilePrescription,
  faNotesMedical,
  faIdCardAlt,
  faCalendarAlt,
  faHospitalUser,
  faArrowDownShortWide,
  faSquareCheck,
  faFilePdf,
  faListCheck,
  faClipboard,
  faUnlock,
  faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";
import ModalTheme from "../../../../shared/components/Modal";
import ModalHistory2 from "../../ClinicHistoryArdila/components/HistoryComplete/ModalHistory";
import AudioFileAdmision from "../../../AudioPanel/AudioFileAdmision";
import ColorStateAdmision from "../../../Admissions/SearchAdmissions/components/ColorStateAdmision";
import ColorStateDoctor from "../../../Admissions/SearchAdmissions/components/ColorStateDoctor";
import TenCorrectAdmission from "../../../Admissions/SearchAdmissions/components/TenCorrectAdmission";
import RadiopharmacyAdmision from "../../../Admissions/SearchAdmissions/components/RadiopharmacyAdmision";
import NotesAdmission from "../../../Admissions/SearchAdmissions/components/NotesAdmission";
import RequestReschedule from "../../../Admissions/SearchAdmissions/components/RequestReschedule";
import PrintModal from "./PrintModal";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import Notes from "../../ClinicHistoryViewIPS/components/Notes/Notes";
import Epicrisis from "../../ClinicHistoryViewIPS/components/Epicrisis/Epicrisis";
import InformedConsent from "../../../Admissions/SearchAdmissions/components/InformedConsent";
import ActivityVisitsPatient from "../../ClinicHistoryViewIPS/components/ClinicalStudio/ActivityVisitsPatient";
import { calculateAgeParse } from "../../../Utils/Patient";
import pdfClincHistory from "../../ClinicEvent/components/PdfReports/PdfHistory";
import FallingRisk from "../../../Admissions/SearchAdmissions/components/FallingRisk";
import VitalSignsHC from "./vitalSigns/VitalSignsHC";
import EpicrisisAddIcon from "@material-ui/icons/PostAdd";

const ReactTableActions = ({
  data,
  refreshData,
  callbackTenCorrect,
  callbackRadioPharmacy,
  callbackupdateCanalization,
  indexPageForm,
  callbackActivityPatientStudio,
  callbackFallingRisks,
  callbackupdateStateClinicHistory,
  callbackupdateStatusPatient,
  callbackupdateStatusVitalSigns,
}) => {
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [modalAlert, setModalAlert] = useState({
    message: "",
    color: "",
    title: "",
    action: 0,
  });
  const [openModal, setOpenModal] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [openModalAudios, setOpenModalAudios] = useState(false);
  const listTipos = sessionStorage.getItem("id_clinica");
  const [userPermits, setUserPermits] = useState([]);
  const [openState, setOpenState] = useState(false);
  const [openStateDoc, setOpenStateDoc] = useState(false);
  const [colorState, setColorState] = useState("#A6ADB6");
  const [colorStateDoc, setColorStateDoc] = useState("#A6ADB6");
  const [openTenCorrect, setOpenTenCorrect] = useState(false);
  const [radioPharmacy, setRadioPharmacy] = useState([]);
  const [radiofarmacos, setRadiofarmacos] = useState([]);
  const [openRadiopharmacyAdmision, setOpenRadiopharmacyAdmission] =
    useState(false);
  const [openNote, setOpenNote] = useState(false);
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [validateProcedure, setValidateProcedure] = useState(false);
  const [admisionAudios, setAdmisionAudios] = useState([]);
  const [existAudioList, setExistAudioList] = useState(false);
  const [getStateImages, setGetStateImages] = useState([]);
  const [modalReagendar, setModalReagendar] = useState(false);
  const [modalMedicalNotes, setModalMedicalNotes] = useState(false);
  const [openInformedConsent, setOpenInformedConsent] = useState(false);
  const [isClinicHistorySpeechTherapy, setIsClinicHistorySpeechTherapy] =
    useState(false); // muestra HC fonoaudiologia
  const [
    openModalCheckActivitiesClinicalStudio,
    setOpenModalCheckActivitiesClinicalStudio,
  ] = useState(false);
  const [askFallingRisks, setAskFallingRisks] = useState(false);
  const [openRisk, setOpenRisk] = useState(false);
  const [openVitalSigns, setOpenVitalSigns] = useState(false);
  const [modalEpicrisis, setModalEpicrisis] = useState(false);

  //imagenologiaColorState
  const [colorDoc, setColorDoc] = useState("#A8ADC2");
  const [messageDoc, setMessageDoc] = useState("Estado del Medico");
  const [colorTecnologo, setColorTecnologo] = useState("#A8ADC2");
  const [messageTecnologo, setMessageTecnologo] = useState(
    "Estado del Tecnologo"
  );
  const [colorTranscriptor, setColorTranscriptor] = useState("#A8ADC2");
  const [messageTranscriptor, setMessageTranscriptor] = useState(
    "Estado del Transcriptor"
  );

  const [printPDFClinicComplete, setPrintPDFClinicComplete] = useState(false);

  const userProfile = sessionStorage.getItem("perfil");
  const selectProced = () => {
    history.push({
      pathname: process.env.PUBLIC_URL + "/pages/medilcal-procedures",
      state: { data: data.data.original },
    });
  };

  const changeColorState = (value) => {
    switch (value) {
      case "1":
        setColorState("#D53E3E");
        break;
      case "2":
        setColorState("#3D8BF3");
        break;
      case "3":
        setColorState("#70D52F");
        break;
      case "4":
        setColorState("#70D52F");
        break;
      case "5":
        setColorState("#F2F236");
        break;
      default:
        setColorState("#A6ADB6");
        break;
    }
    setOpenState(false);
  };
  //setColorState - setColorStateDoc
  const changeColorStateDoc = (value) => {
    switch (value) {
      case "1":
        setColorStateDoc("#D16BCF");
        break;
      case "2":
        setColorStateDoc("#D53E3E");
        break;
      case "3":
        setColorStateDoc("#3D8BF3");
        break;
      case "4":
        setColorState("#70D52F");
        break;
      case "5":
        setColorState("#F2F236");
        break;
      default:
        setColorStateDoc("#A6ADB6");
        break;
    }

    setOpenStateDoc(false);
  };

  const stateDoctorProfile = (res) => {
    if (res !== undefined && res !== null) {
      let imagesState = res.filter((image) => image.seleccionado !== false);
      //console.log("STATE", imagesState, "IMAGES", res);
      if (Object.entries(imagesState).length === 0) {
        setMessageDoc("No existen imagenes para este procedimiento");
        setColorDoc("#A8ADC2");
      } else {
        if (data.data.original.imagenologia_pendiente !== true) {
          if (data.data.original.imagenologia_aprobada !== false) {
            setMessageDoc(
              "Las imágenes para este procedimiento han sido aprobadas"
            );
            setColorDoc("#008f39");
          } else {
            setMessageDoc(
              "Las imágenes para este procedimiento han sido rechazadas"
            );
            setColorDoc("#FF0000");
          }
        } else {
          if (data.data.original.estado_transcripcion === 2) {
            setMessageDoc("La Transcripción esta aprobada");
            setColorDoc("#008f39");
          } else {
            setMessageDoc("Las imágenes están Pendientes de ser evaluadas");
            setColorDoc("#FFB900");
          }
        }
      }
    } else {
      setMessageDoc("No existen imagenes para este procedimiento");
      setColorDoc("#A8ADC2");
    }
  };

  const stateTecnologoProfile = (res) => {
    // imagenologia_pendiente ---> cambia a false cuando el medico decide sobre las imagenes / cambia a true cuando hay imagenes
    if (res !== undefined && res !== null) {
      let imagesState = res.filter((image) => image.seleccionado !== false);
      //console.log("STATE", imagesState, "IMAGES", res);
      if (Object.entries(imagesState).length === 0) {
        setMessageTecnologo(
          "No se han enviado imagenes al profesional para este procedimiento"
        );
        setColorTecnologo("#A8ADC2");
      } else {
        if (data.data.original.imagenologia_pendiente !== true) {
          if (data.data.original.imagenologia_aprobada !== false) {
            setMessageTecnologo(
              "Las imágenes para este procedimiento han sido aprobadas por el profesional"
            );
            setColorTecnologo("#008f39");
          } else {
            setMessageTecnologo(
              "Las imágenes para este procedimiento han sido rechazadas por el profesional"
            );
            setColorTecnologo("#FF0000");
          }
        } else {
          if (data.data.original.estado_transcripcion === 2) {
            setMessageTecnologo("La Transcripción esta aprobada");
            setColorTecnologo("#008f39");
          } else {
            setMessageTecnologo(
              "Las imágenes están Pendientes de ser evaluadas por el profesional"
            );
            setColorTecnologo("#FFB900");
          }
        }
      }
    } else {
      setMessageTecnologo("No existen imagenes para este procedimiento");
      setColorTecnologo("#A8ADC2");
    }
  };

  const stateTtanscriptorProfile = (res) => {
    if (JSON.stringify(res) == "[]") {
      setMessageTranscriptor("No existen audios para transcribir");
      setColorTranscriptor("#A8ADC2");
    } else {
      let isTransciption = res.map((tran) => tran.transcripcion !== null);
      if (data.data.original.estado_transcripcion == null) {
        setMessageTranscriptor("Existen audios pendientes para transcribir");
        setColorTranscriptor("#FFB900");
      } else if (data.data.original.estado_transcripcion == 1) {
        setMessageTranscriptor(
          "La transcripción fue enviada al profesional. Pendiente de su aprobación"
        );
        setColorTranscriptor("#F8FF00");
      } else if (data.data.original.estado_transcripcion == 2) {
        setMessageTranscriptor(
          "La transcripción fue aprobada por el profesional"
        );
        setColorTranscriptor("#008f39");
      } else {
        setMessageTranscriptor(
          "La transcripción fue rechazada por el profesional"
        );
        setColorTranscriptor("#FF0000");
      }
    }
  };

  const validatePermissionsClinicHistory = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        setUserPermits(perfil);
      } else {
        var perfil = [];
        setUserPermits(perfil);
      }
    } else {
      setUserPermits([]);
    }
  };

  const validateCHFonoaudiologia = () => {
    var clinic = JSON.parse(sessionStorage.getItem("clinica"));
    setIsClinicHistorySpeechTherapy(clinic?.fonoaudiologia_v1);
  };

  useEffect(() => {
    validatePermissionsClinicHistory();
    validateCHFonoaudiologia();
    stateDoctorProfile();
    validateShowInfoClinic();
    stateTecnologoProfile();
    getDataFiles();
    loadColors();
    validateProcedureGamaEco();
    console.log({ dataOriginal: data.data.original });
    if (admisionAudios.length > 0) {
      setExistAudioList(true);
    }
  }, []);

  const validateProcedureGamaEco = () => {
    try {
      console.log("servicios",data.data.original.servicios);
      let existeGamagrafia = data.data.original.servicios.some((ser) => {
        let verifyCups = ser.codigo ?? ser.cupscod;
        let verifyAislamiento = ser.ind_hospitalizacion;
        let isTerapia = ser.nombre.toUpperCase().includes("TERAPIA");

        if (
          isTerapia &&
          (verifyAislamiento === false || verifyAislamiento === null)
        ) {
          return true;
        }

        return (
          ser.nombre.toUpperCase().search("GAMAGRAFIA") != -1 ||
          (verifyCups.startsWith("92") && !verifyCups.startsWith("9228")) || (verifyCups.startsWith("922801PL")) || (verifyCups.startsWith("922803-2") || verifyCups.startsWith("922803-4")  || verifyCups.startsWith("922803"))
        );
      });

      let existeEcografia = data.data.original.servicios.some((ser) => {
        let verifyCups = ser.codigo ?? ser.cupscod;
        return (
          ser.nombre.toUpperCase().includes("ECOGRAFIA") ||
          verifyCups.substr(0, 2) === "88" ||
          verifyCups.substr(0, 2) == "87" ||
          verifyCups.substr(0, 4) === "3130"
        );
      });

      if (existeGamagrafia || existeEcografia) {
        setValidateProcedure(true);
        listAudio();
      } else {
        setValidateProcedure(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadColors = () => {
    //Estado Doctor
    if (
      data.data.original.estado_medico != null &&
      data.data.original.estado_medico != undefined
    ) {
      changeColorStateDoc(data.data.original.estado_medico.toString());
    } else {
      changeColorStateDoc(null);
    }

    //Estado Imagenes
    if (
      data.data.original.estado_imagenes != null &&
      data.data.original.estado_imagenes != undefined
    ) {
      changeColorState(data.data.original.estado_imagenes.toString());
    } else {
      changeColorState(null);
    }
  };

  const loadRadioPharmacy = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-radiofarmaco/listar-por-admision?id_admision=" +
        data.data.original.id_admision,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response[0] !== undefined && response[0] !== null) {
          setRadioPharmacy(response);
          /* setRadioPharmacy(
            response.find(
              (radiofarmaco) =>
                data.data.original.id_admision == radiofarmaco.id_admision
            )
          ); */
          setRadiofarmacos(
            response.filter(
              (radiofarmaco) =>
                radiofarmaco.id_admision ==
                data.data.original.id_admision_cita_padre
            )
          );
        } else {
          setRadioPharmacy([]);
          setRadiofarmacos([]);
        }
        setOpenRadiopharmacyAdmission(true);
      })
      .catch((err) => {
        setRadioPharmacy(null);
        setRadiofarmacos([]);
        setOpenRadiopharmacyAdmission(false);
      });
  };

  const listAudio = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-audios/listar?id_admision=" +
        data.data.original.id_admision,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error");
        }
      })
      .then((res) => {
        setAdmisionAudios(res);
        console.log("ListaAudios", res, "stateLenght", admisionAudios);
        stateTtanscriptorProfile(res);
      })
      .catch((error) => {
        console.log(error);
        setAdmisionAudios([]);
        setExistAudioList(false);
      });
  };

  const getDataFiles = async () => {
    let dataSend = {
      id_historia: parseInt(data.data.original.id_historia),
      id_admision: parseInt(data.data.original.id_admision),
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "archivos/consultar-imagenes",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setGetStateImages(data);
        stateDoctorProfile(data);
        stateTecnologoProfile(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const closeAdmission = () => {
    let today = new Date();
    var dataClose = {
      id_admision: data.data.original.id_admision,
      fecha_cierre: today,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "admision/close", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataClose),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //alert(data);
        setOpenAlertModal(true);
        setModalAlert({
          message: "Admisión cerrada",
          color: "success",
          title: "Exitoso!",
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const reopenEventHistory = async () => {
    let dataSend = { id_admision: data.data.original.id_admision };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "evento/reabrir_historia", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        console.log(data);
        if (!!data) {
          setOpenAlertModal(true);
          setModalAlert({
            message: "La historia clinica se reabrió",
            color: "success",
            title: "Exitoso!",
          });
        } else {
          setOpenAlertModal(true);
          setModalAlert({
            message: "No se pudo reabrir la historia clinica",
            color: "danger",
            title: "Error!",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const changeCheckStatusPatient = async () => {
    let dataSend = {
      id_admision: data.data.original.id_admision,
      check_paciente: !data.data.check_paciente,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "fisico/update-estado-paciente",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        console.log(data);
        if (data.contenido.listado) {
          setOpenAlertModal(true);
          setModalAlert({
            message: "El estado se cambio correctamente",
            color: "success",
            title: "Exitoso!",
            action: 2,
          });
        } else {
          setOpenAlertModal(true);
          setModalAlert({
            message: "No se pudo actualizar la historia clinica",
            color: "danger",
            title: "Error!",
            action: 2,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadImagingFile = () => {
    history.push({
      pathname:
        process.env.PUBLIC_URL + "/assitencial/upload-diagnostic-images",
      state: { dataPatient: data.data.original, pageIndex: indexPageForm },
    });
  };

  const requestRescheduling = () => {
    setModalReagendar(true);
  };

  const getClinicHistory = (id_historia) => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "evento/consultar/historia_clinica/" +
          id_historia,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //console.log(data);
          resolve(data);
          //setInfoClinicHistoryComplete(data.admisiones);
        })
        .catch((error) => {
          alert(error);
          console.error("Error:", error);
        });
    });
  };

  const makePDFComplete = async (dataRow) => {
    let infoAdmissionByPatient = await getClinicHistory(dataRow?.id_historia);
    console.log(
      "infoAdmissionByPatient",
      infoAdmissionByPatient.admisiones,
      "dataRow",
      dataRow
    );
    let pacientInfo;
    if (
      infoAdmissionByPatient !== null &&
      infoAdmissionByPatient !== undefined
    ) {
      if (infoAdmissionByPatient.hasOwnProperty("paciente")) {
        pacientInfo = infoAdmissionByPatient.paciente;
      }
    }
    console.log("pacientInfo", pacientInfo);
    const data = {
      today: new Date(),
      urlLogo: sessionStorage.getItem("logoURL"),
      names: dataRow?.fullname,
      day: dataRow?.fecha,
      admissions: infoAdmissionByPatient.admisiones,
      telephone: pacientInfo?.telefono1,
      cellphone: pacientInfo?.celular,
      id_historia: dataRow?.id_historia,
      id_admision: dataRow?.id_admision,
      documentNumber: dataRow?.num_documento,
      typeOfDocument: dataRow?.tip_documento,
      birthday: dataRow?.birthday,
      age: calculateAgeParse(dataRow?.birthday),
      profile: JSON.parse(sessionStorage.getItem("clinica")),
      address: dataRow?.address?.direccion,
      gender: dataRow?.sexo,
      city: dataRow?.address?.ciudad,
      civilStatus: pacientInfo?.e_civil,
      bloodType: pacientInfo?.tipo_sangre,
      ordenes: null,
      professional: null,
    };
    setPrintPDFClinicComplete(true);
    pdfClincHistory(data, "PDF", null);
  };

  const goToEventAdverseClinicalStudio = () => {
    history.push({
      pathname: process.env.PUBLIC_URL + "/assitencial/event-adverse",
      state: {
        data: data.data.original,
        pageIndex: indexPageForm,
        id_historia: data.data.original.id_historia,
      },
    });
  };

  const validateShowInfoClinic = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));
    setAskFallingRisks(
      clinica.hasOwnProperty("solicitar_riesdo_caida")
        ? clinica.solicitar_riesdo_caida
        : false
    );
  };

  const onOkModal = () => {
    switch (modalAlert.color) {
      case "success":
        switch (modalAlert.action) {
          case 1:
            callbackupdateStateClinicHistory(
              data.data.original.id_admision,
              false
            );
            setOpenAlertModal(!openAlertModal);
            break;
          case 2:
            callbackupdateStatusPatient(data.data.original.id_admision, true);
            callbackupdateStateClinicHistory(
              data.data.original.id_admision,
              true
            );
            setOpenAlertModal(!openAlertModal);
          default:
            setOpenAlertModal(!openAlertModal);
            break;
        }
        break;
      case "warning":
        switch (modalAlert.action) {
          case 1:
            reopenEventHistory();
            break;
          case 2:
            changeCheckStatusPatient();
          default:
            setOpenAlertModal(!openAlertModal);
            break;
        }
        break;
      case "danger":
        setOpenAlertModal(!openAlertModal);
        break;
    }
    setOpenAlertModal(!openAlertModal);
  };

  return (
    <Fragment>
      <td role="cell" className="button-action-react-table">
        {/*data.data.original.perfil === "10" || data.data.original.perfil === "11" ? null : (
        <Tooltip title="Procedimiento">
          <IconButton aria-label="launch"
            style={{ padding: 2 }}
            onClick={selectProced}>
            <AssignmentIcon />
          </IconButton>
        </Tooltip>_____
      )*/}

        {/* {listTipos.includes('3') ?
        userProfile == 9 || userProfile == 16 || userProfile == 10 || userProfile == 17 ?
          <Tooltip title="Estado del Tecnologo">
            <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: colorState }}
              onClick={() => {
                if (userProfile == 9 || userProfile == 16)
                  setOpenState(true);
              }}
            >
              <Brightness1Icon style={{ color: colorState }} />
            </IconButton>
          </Tooltip>
          : null
        : null
      } */}
        {listTipos.includes("3") ? (
          (userProfile == 10 ||
            userProfile == 9 ||
            userProfile == 19 ||
            userPermits.includes(43)) &&
          validateProcedure == true ? (
            <Tooltip className="icon-action-elmt" title={messageDoc}>
              <IconButton
                aria-label="launch"
                color="inherit"
                style={{ padding: 2 }}
                onClick={() => {}}
              >
                <Brightness1Icon style={{ color: colorDoc }} />
              </IconButton>
            </Tooltip>
          ) : null
        ) : null}

        {listTipos.includes("3") ? (
          (userProfile == 16 ||
            userProfile == 9 ||
            userProfile == 19 ||
            userPermits.includes(41)) &&
          validateProcedure == true ? (
            <Tooltip className="icon-action-elmt" title={messageTecnologo}>
              <IconButton
                aria-label="launch"
                color="inherit"
                style={{ padding: 2 }}
                onClick={() => {}}
              >
                <Brightness1Icon style={{ color: colorTecnologo }} />
              </IconButton>
            </Tooltip>
          ) : null
        ) : null}

        {listTipos.includes("3") ? (
          (userProfile == 20 || userProfile == 9 || userProfile == 19) &&
          validateProcedure == true ? (
            <Tooltip className="icon-action-elmt" title={messageTranscriptor}>
              <IconButton
                aria-label="launch"
                color="inherit"
                style={{ padding: 2 }}
                onClick={() => {}}
              >
                <Brightness1Icon style={{ color: colorTranscriptor }} />
              </IconButton>
            </Tooltip>
          ) : null
        ) : null}

        {/* validateProcedure si es una consulta es false, si es una gamagrafia es true */}
        {userPermits.includes(32) || userPermits.includes(33) ? (
          <>
            {data.data.original.studio ? (
              <>
                {/*<Tooltip className="icon-action-elmt" title="Historia Estudios Clinicos">
              <IconButton aria-label="launch"
                style={{ padding: 2 }}
                onClick={() => {
                  history.push({
                    pathname: process.env.PUBLIC_URL + '/assitencial/clinic-history',
                    state: { data: data.data.original }
                  });
                }}>
                <LaunchIcon style={{ color: '#000' }} />
              </IconButton>
            </Tooltip>*/}

                <Tooltip
                  className="icon-action-elmt"
                  title="Ver Historia Clinica"
                >
                  <IconButton
                    aria-label="launch"
                    style={{ padding: 2 }}
                    onClick={() => {
                      history.push({
                        pathname:
                          process.env.PUBLIC_URL +
                          "/assitencial/clinic-history2",
                        state: {
                          data: data.data.original,
                        },
                      });
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faNotesMedical}
                      style={{ color: "#A8ADC2" }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            ) : validateProcedure == false ? (
              <Fragment>
                <Tooltip
                  className="icon-action-elmt"
                  title="Ver Historia Clinica"
                >
                  <IconButton
                    aria-label="launch"
                    style={{ padding: 2 }}
                    onClick={() => {
                      history.push({
                        pathname:
                          process.env.PUBLIC_URL +
                          "/assitencial/clinic-history2",
                        state: {
                          data: data.data.original,
                          pageIndex: indexPageForm,
                        },
                      });
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faNotesMedical}
                      style={{ color: "#A8ADC2" }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  className="icon-action-elmt"
                  title="Ver PDF Historia Clinica"
                >
                  <IconButton
                    aria-label="launch"
                    style={{ padding: 2 }}
                    onClick={() => {
                      makePDFComplete(data.data.original);
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faFilePdf}
                      style={{ color: "#A8ADC2" }}
                    />
                  </IconButton>
                </Tooltip>
              </Fragment>
            ) : null}

            {userPermits.includes(32) &&
            userPermits.includes(34) &&
            isClinicHistorySpeechTherapy ? (
              <Tooltip className="icon-action-elmt" title="Historia Clinica ">
                <IconButton
                  aria-label="launch"
                  style={{ padding: 2 }}
                  onClick={() => {
                    history.push({
                      pathname:
                        process.env.PUBLIC_URL + "/assitencial/clinic-history4",
                      state: {
                        data: data.data.original,
                        pageIndex: indexPageForm,
                      },
                    });
                  }}
                >
                  <FontAwesomeIcon
                    icon={faFileMedical}
                    style={{ color: "#A8ADC2" }}
                  />
                </IconButton>
              </Tooltip>
            ) : null}
            {userPermits.includes(32) &&
            userPermits.includes(34) &&
            isClinicHistorySpeechTherapy ? (
              <Tooltip
                className="icon-action-elmt"
                title="Historia Completa (Formato Fonoaudiologia)"
              >
                <IconButton
                  aria-label="launch"
                  style={{ padding: 2 }}
                  onClick={() => {
                    setModalHistory(true);
                  }}
                >
                  <AssignmentIcon style={{ color: "#4A3C1A" }} />
                </IconButton>
              </Tooltip>
            ) : null}

            {listTipos.includes("3") &&
            (userPermits.includes(32) || userPermits.includes(43)) &&
            validateProcedure == true ? (
              <Tooltip
                className="icon-action-elmt"
                title="Historia Clinica Procedimientos"
              >
                <IconButton
                  aria-label="launch"
                  style={{ padding: 2 }}
                  onClick={() => {
                    history.push({
                      pathname:
                        process.env.PUBLIC_URL + "/assitencial/clinic-history3",
                      state: {
                        data: data.data.original,
                        pageIndex: indexPageForm,
                      },
                    });
                  }}
                >
                  {/* <ImageSearchIcon style={{ color: '#97A090' }} />  */}
                  <QueueIcon style={{ color: "#97A090" }} />
                  {/* <FontAwesomeIcon icon={faIdCardAlt} style={{ color: '#97A090' }} /> */}
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        ) : null}
        {/* {
        userProfile == 9 || userProfile == 16 || userProfile == 10 || userProfile == 17 || userProfile == 20 || userProfile == 19 || userPermits.includes(11) ?
          <Tooltip className="icon-action-elmt" title="Ver Historia Clinica Completa">
            <IconButton aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenModal(true);
              }}>
              <ListAltIcon style={{ color: '#153365' }} />
            </IconButton>
          </Tooltip> : null
      } */}

        {userProfile == 9 ||
        userProfile == 10 ||
        userProfile == 16 ||
        userProfile == 19 ||
        userPermits.includes(11) ? (
          <Tooltip className="icon-action-elmt" title="Impresiones">
            <IconButton
              aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenPrintModal(true);
              }}
            >
              <PrintIcon style={{ color: "#8F8F88" }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {userPermits.includes(57) ? (
          <Tooltip className="icon-action-elmt" title="10 correctos">
            <IconButton
              aria-label="ten-corrects"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenTenCorrect(!openTenCorrect);
              }}
            >
              <AssignmentIcon
                style={{
                  color:
                    data.data.original.correctos != null ? "green" : "#4A3C1A",
                }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {askFallingRisks && userPermits.includes(59) ? (
          <Tooltip className="icon-action-elmt" title="Riesgo de Caida">
            <IconButton
              aria-label="falling-risk"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenRisk(!openRisk);
              }}
            >
              <FontAwesomeIcon
                icon={faListCheck}
                style={{
                  width: "0.8em",
                  height: "0.8em",
                  color: data.data.original.riesgo_caidas.hasOwnProperty(
                    "riesgo"
                  )
                    ? data.data.original.riesgo_caidas.riesgo !== ""
                      ? "green"
                      : "#4A3C1A"
                    : "#4A3C1A",
                }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {userPermits.includes(11) ? (
          <Tooltip className="icon-action-elmt" title="Observaciones">
            <IconButton
              aria-label="observations"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenNote(!openNote);
              }}
            >
              <DescriptionIcon style={{ color: "#A8ADC2" }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {
          /* (!sessionStorage.getItem("nombreperfil").includes("ENFERMERIA") &&
        !sessionStorage.getItem("nombreperfil").includes("TECNOLOGO")) &&
         */
          userProfile == 9 || //adm - en tulua y armenia
          userProfile == 16 || //tec
          userProfile == 10 || //med
          userProfile == 17 || //aux
          userProfile == 19 || //auditor
          userPermits.includes(11) ? (
            <Tooltip className="icon-action-elmt" title="Notas evolutivas">
              <IconButton
                aria-label="medicalNotes"
                style={{ padding: 2 }}
                onClick={() => {
                  setModalMedicalNotes(!modalMedicalNotes);
                }}
              >
                <NoteAddIcon style={{ color: "#A8ADC2" }} />
              </IconButton>
            </Tooltip>
          ) : null
        }

        {!sessionStorage.getItem("nombreperfil").includes("ENFERMERIA") &&
        !sessionStorage.getItem("nombreperfil").includes("TECNOLOGO") &&
        (userProfile == 9 ||
          userProfile == 16 ||
          userProfile == 10 ||
          userProfile == 17 ||
          userProfile == 19 ||
          userPermits.includes(11)) ? (
          <Tooltip className="icon-action-elmt" title="Epicrisis">
            <IconButton
              aria-label="Epicrisis"
              onClick={() => {
                setModalEpicrisis(!modalEpicrisis);
              }}
            >
              <EpicrisisAddIcon style={{ color: "#A8ADC2" }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {userPermits.includes(42) && validateProcedure == true ? (
          listTipos.includes("3") ? (
            <Fragment>
              <Tooltip className="icon-action-elmt" title="Registro Clínico">
                <IconButton
                  aria-label="add"
                  style={{ padding: 2 }}
                  onClick={() => {
                    history.push({
                      pathname:
                        process.env.PUBLIC_URL + "/assitencial/interview",
                      state: {
                        dataPatient: data.data.original,
                        radioFarmacia: radioPharmacy,
                        pageIndex: indexPageForm,
                      },
                    });
                  }}
                >
                  <AddCircleOutlineIcon
                    style={{
                      color:
                        data.data.original.entrevista_realizada === true ||
                        (data.data.original.id_admision_cita_padre !== null &&
                          data.data.original.id_admision_cita_padre !==
                            undefined)
                          ? "green"
                          : "#70bbfd",
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                className="icon-action-elmt"
                title="Consentimiento Informado"
              >
                <IconButton
                  aria-label="launch"
                  style={{ padding: 2 }}
                  onClick={() => {
                    setOpenInformedConsent(true);
                  }}
                >
                  {
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      style={{
                        color:
                          data.data.original
                            .consentimiento_informado_validado == true
                            ? "green"
                            : "#000",
                      }}
                    />
                  }
                </IconButton>
              </Tooltip>
            </Fragment>
          ) : null
        ) : null}

        {(userProfile == 9 ||
          userProfile == 16 ||
          userProfile == 17 ||
          userProfile == 10 ||
          userProfile == 19 ||
          userPermits.includes(44)) &&
        validateProcedure == true ? (
          listTipos.includes("3") ? (
            <Tooltip
              className="icon-action-elmt"
              title="Registrar Radiofarmaco"
            >
              <IconButton
                aria-label="activity-visit"
                style={{ padding: 2 }}
                onClick={() => {
                  loadRadioPharmacy();
                }}
              >
                <FontAwesomeIcon
                  icon={faRadiation}
                  style={{
                    color:
                      data.data.original.radiofarmaco_aplicado === true
                        ? "green"
                        : "black",
                  }}
                />
              </IconButton>
            </Tooltip>
          ) : null
        ) : null}

        <Tooltip className="icon-action-elmt" title="Agregar archivo">
          <IconButton
            aria-label="attach-file"
            style={{ padding: 2 }}
            onClick={() => {
              //sessionStorage.setItem('searchAdmisionState', this.state);
              history.push({
                pathname:
                  process.env.PUBLIC_URL + "/assitencial/files-admission",
                state: {
                  dataPatient: data.data.original,
                  pageIndex: indexPageForm,
                  previousUrl: "/assitencial/search-clinic-history",
                },
              });
            }}
          >
            <AttachFileIcon style={{ color: "#888888" }} />
          </IconButton>
        </Tooltip>

        {listTipos.includes("3") ? (
          userPermits.includes(41) && validateProcedure == true ? (
            <Tooltip
              className="icon-action-elmt"
              title="Subir Imagenes Diagnosticas"
            >
              <IconButton
                aria-label="activity-visit"
                style={{ padding: 2 }}
                onClick={() => {
                  loadImagingFile();
                }}
              >
                <FontAwesomeIcon
                  icon={faFilePrescription}
                  style={{ color: colorTecnologo }}
                />
              </IconButton>
            </Tooltip>
          ) : null
        ) : null}

        {userPermits.includes(30) && validateProcedure == true ? (
          <Tooltip
            className="icon-action-elmt"
            title="Lista de Audios y Transcripción"
          >
            <IconButton
              aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenModalAudios(true);
              }}
            >
              <FontAwesomeIcon
                icon={faFileAudio}
                style={{ color: colorTranscriptor }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {listTipos.includes("3") && !data.data.original.studio ? (
          <Tooltip className="icon-action-elmt" title="Reagendar Admisión">
            <IconButton
              aria-label="attach-file"
              style={{ padding: 2 }}
              onClick={() => {
                requestRescheduling();
              }}
            >
              <FontAwesomeIcon
                icon={faCalendarAlt}
                style={{ color: "#000", width: "0.8em", height: "0.8em" }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {userPermits.includes(61) && data.data.original.historia_cerrada ? (
          <Tooltip
            className="icon-action-elmt"
            title="Reabrir Historia Clínica"
          >
            <IconButton
              aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenAlertModal(true);
                setModalAlert({
                  message: "¿Esta seguro de reabrir la historia Clínica?",
                  color: "warning",
                  title: "Advertencia!",
                  action: 1,
                });
              }}
            >
              <FontAwesomeIcon
                icon={faUnlock}
                style={{ width: "0.8em", height: "0.8em" }}
              />
            </IconButton>
          </Tooltip>
        ) : null}

        {userPermits.includes(62) ? (
          <Fragment>
            <Tooltip
              className="icon-action-elmt"
              title="Signos vitales | Antropometría Historia Clinica"
            >
              <IconButton
                aria-label="launch"
                style={{ padding: 2 }}
                onClick={() => {
                  setOpenVitalSigns(true);
                }}
              >
                <FontAwesomeIcon
                  icon={faHeartPulse}
                  style={{
                    color:
                      data.data.original.signos_vitales_realizados === true
                        ? "green"
                        : "black",
                    width: "0.8em",
                    height: "0.8em",
                  }}
                />
              </IconButton>
            </Tooltip>
            {data.data.original.signos_vitales_realizados ? (
              <Tooltip
                className="icon-action-elmt"
                title="Cambiar estado de la atención del paciente"
              >
                <span>
                  <IconButton
                    aria-label="launch"
                    style={{ padding: 2 }}
                    disabled={data.data.original.check_paciente}
                    onClick={() => {
                      setOpenAlertModal(true);
                      setModalAlert({
                        message:
                          "¿Esta seguro de cambiar el estado de la atención del paciente?",
                        color: "warning",
                        title: "Advertencia!",
                        action: 2,
                      });
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{
                        color:
                          data.data.original.check_paciente === true
                            ? "green"
                            : "black",
                        width: "0.8em",
                        height: "0.8em",
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
            ) : null}
          </Fragment>
        ) : null}

        {data.data.original.studio ? (
          <>
            <Tooltip className="icon-action-elmt" title="Check de Visita">
              <IconButton
                aria-label="attach-file"
                disabled={
                  data.data.original.id_estudio_paciente == null ? true : false
                }
                onClick={() => {
                  setOpenModalCheckActivitiesClinicalStudio(true);
                }}
              >
                <FontAwesomeIcon
                  icon={faSquareCheck}
                  style={{
                    padding: 2,
                    color:
                      data.data.original.id_estudio_paciente != null &&
                      data.data.original.actividades_realizadas == true
                        ? "green"
                        : data.data.original.id_estudio_paciente == null &&
                          data.data.original.actividades_realizadas == true
                        ? "aed6ae"
                        : data.data.original.id_estudio_paciente != null &&
                          data.data.original.actividades_realizadas == false
                        ? "black"
                        : "#9c9c9c",
                  }}
                />
              </IconButton>
            </Tooltip>

            <Tooltip className="icon-action-elmt" title="Evento Adverso">
              <IconButton
                aria-label="attach-file"
                style={{ padding: 2 }}
                onClick={() => {
                  goToEventAdverseClinicalStudio();
                }}
              >
                <FontAwesomeIcon
                  icon={faHospitalUser}
                  style={{ color: "#000" }}
                />
              </IconButton>
            </Tooltip>

            <Tooltip
              className="icon-action-elmt"
              title="Desviación del Protocolo"
            >
              <IconButton
                aria-label="attach-file"
                style={{ padding: 2 }}
                onClick={() => {
                  console.log("");
                }}
              >
                <FontAwesomeIcon
                  icon={faArrowDownShortWide}
                  style={{ color: "#000" }}
                />
              </IconButton>
            </Tooltip>
          </>
        ) : null}
      </td>
      {openState ? (
        <ColorStateAdmision
          admision={data.data.original}
          openState={openState}
          setOpenState={setOpenState}
          changeColorState={changeColorState}
        />
      ) : null}
      {openStateDoc ? (
        <ColorStateDoctor
          admision={data.data.original}
          openStateDoc={openStateDoc}
          setOpenStateDoc={setOpenStateDoc}
          changeColorStateDoc={changeColorStateDoc}
        />
      ) : null}
      {modalHistory ? (
        <ModalHistory2
          data={data.data.original}
          openModal={modalHistory}
          setOpenModal={setModalHistory}
        />
      ) : null}
      {openNote ? (
        <NotesAdmission
          data={data.data}
          openNote={openNote}
          setOpenNote={setOpenNote}
        />
      ) : null}
      {openTenCorrect ? (
        <TenCorrectAdmission
          data={data.data}
          openTenCorrect={openTenCorrect}
          setOpenTenCorrect={setOpenTenCorrect}
          callbackTenCorrect={callbackTenCorrect}
        />
      ) : null}
      {openPrintModal ? (
        <PrintModal
          data={data.data.original}
          openPrintModal={openPrintModal}
          setOpenPrintModal={setOpenPrintModal}
        />
      ) : null}
      {openModal ? (
        <ModalHistory
          data={data.data.original}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : null}
      {openRisk ? (
        <FallingRisk
          data={data.data.original}
          openRisk={openRisk}
          setOpenRisk={setOpenRisk}
          callbackFallingRisks={callbackFallingRisks}
        />
      ) : null}
      {openVitalSigns ? (
        <Modal
          open={openVitalSigns}
          onClose={(e) => {
            setOpenVitalSigns(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <VitalSignsHC
              data={data.data.original}
              openVitalSigns={openVitalSigns}
              setOpenVitalSigns={setOpenVitalSigns}
              callbackupdateStatusVitalSigns={callbackupdateStatusVitalSigns}
            />
          </div>
        </Modal>
      ) : null}
      {openRadiopharmacyAdmision ? (
        <RadiopharmacyAdmision
          data={data.data}
          opened={openRadiopharmacyAdmision}
          closeMedicineAdmision={(open) => setOpenRadiopharmacyAdmission(open)}
          radiofarmacos={radiofarmacos}
          radioPharmacy={radioPharmacy}
          loadRadioPharmacy={loadRadioPharmacy}
          callbackRadioPharmacy={callbackRadioPharmacy}
          callbackupdateCanalization={callbackupdateCanalization}
        />
      ) : null}
      {openModalAudios ? (
        <AudioFileAdmision
          dataPatient={data.data.original}
          data={data.data.original}
          id_admision={data.data.original.id_admision}
          audioRecOpen={openModalAudios}
          refreshData={refreshData}
          closeAudioRec={() => setOpenModalAudios(false)}
        />
      ) : null}
      {openInformedConsent ? (
        <InformedConsent
          data={data.data.original}
          opened={openInformedConsent}
          closeModalInformedConsent={() => setOpenInformedConsent(false)}
        />
      ) : null}

      {modalMedicalNotes ? (
        <Modal
          open={modalMedicalNotes}
          onClose={(e) => {
            setModalMedicalNotes(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <Notes data={data.data.original} userPermits={userPermits} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{ marginTop: 10 }}
                color="primary"
                onClick={() => {
                  setModalMedicalNotes(!modalMedicalNotes);
                }}
              >
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}

      {modalEpicrisis ? (
        <Modal
          open={modalEpicrisis}
          onClose={(e) => {
            setModalMedicalNotes(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <Epicrisis data={data.data.original} userPermits={userPermits} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{ marginTop: 10 }}
                color="primary"
                onClick={() => {
                  setModalEpicrisis(!modalEpicrisis);
                }}
              >
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}

      {modalReagendar ? (
        <RequestReschedule
          opened={modalReagendar}
          closeModal={() => setModalReagendar(false)}
          motivo_reagendamiento={data.data.motivo_reagendamiento}
          id_admision={data.data.original.id_admision}
        />
      ) : null}

      {openModalCheckActivitiesClinicalStudio == true ? (
        <>
          <ActivityVisitsPatient
            data={data.data.original}
            enableLucnhAndTransport={false}
            enableActivitiesList={true}
            closeOpenActivityVisit={() =>
              setOpenModalCheckActivitiesClinicalStudio(false)
            }
            opened={openModalCheckActivitiesClinicalStudio}
            id_estudio_paciente={data.data.original.id_estudio_paciente}
            callbackActivityPatientStudio={(
              id_admision,
              value,
              id_estudio_paciente
            ) =>
              callbackActivityPatientStudio(
                id_admision,
                value,
                id_estudio_paciente
              )
            }
          />
        </>
      ) : null}

      <ModalTheme
        color={modalAlert.color}
        title={modalAlert.title}
        message={modalAlert.message}
        modal={openAlertModal}
        onOk={() => onOkModal()}
        toggle={() => {
          setOpenAlertModal(!openAlertModal);
        }}
      ></ModalTheme>

      {printPDFClinicComplete ? (
        <Modal
          open={printPDFClinicComplete}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "90%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setPrintPDFClinicComplete(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <div className="container-pdfs-modal">
              <iframe className="iframe-pdfs" id="pdfV"></iframe>
            </div>
          </div>
        </Modal>
      ) : null}
    </Fragment>
  );
};

export default ReactTableActions;
